import HotKey from './hot-key';

export default HotKey;
